module.exports = __webpack_public_path__ + "media/images/noticia03-2-830193b6c8a5fc6149eba9cda2a45778.jpeg";